import { css, styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

import Typography from '@mui/material/Typography';
import { Input as InputComponent } from '../../../../components/Input';

interface ButtonProps {
  isActived: boolean;
}

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: overlay;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #212121;
    margin-bottom: 20px;
  }
`;

export const HeaderCreate = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 0px 16px;
  border-bottom: 1px solid #bdbdbd;
  margin-bottom: 20px;
  position: relative;
`;

export const Title = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 23px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;

export const Section = styled(Box)`
  height: 100%;
  &.disabled {
    background-color: ${({ theme }) => theme.palette.grey[400]};
    cursor: not-allowed;

    button {
      border-radius: 32px;
      height: 24px;
      color: ${({ theme }) => theme.palette.common.white};
      text-transform: capitalize;
      background-color: ${({ theme }) => theme.palette.grey.A100};
    }
  }

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ul {
      padding: 0;
    }

    li {
      list-style: none;
    }
  }

  .content-guests {
    padding: 5px 20px 0px 20px;
  }

  .meeting-details {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    margin-bottom: 20px;
  }

  .buttons {
    display: flex;
    gap: 20px;
  }

  .btn-cancel {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 32px;
    width: 64px;
    height: 24px;
    text-transform: capitalize;
  }

  .btn-save {
    background: #4caf50;
    border-radius: 32px;
    width: 151px;
    height: 24px;
    color: ${({ theme }) => theme.palette.common.white};
    text-transform: capitalize;
  }

  h4 {
    margin: 5px 0 5px 0;
    padding: 0;
  }

  .input-date {
    display: flex;
    flex-direction: row;
    gap: 20px;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 1rem;
  }

  .inputs {
    width: 100%;
  }

  .initial-input {
    width: 90%;
    ::-webkit-datetime-local-edit-year-field:not([aria-valuenow]),
    ::-webkit-datetime-local-edit-month-field:not([aria-valuenow]),
    ::-webkit-datetime-local-edit-day-field:not([aria-valuenow]) {
      color: transparent;
    }
  }

  .btn-repetition {
    /* width: 134px; */
    display: flex;
    align-items: center;
    gap: 10px;
    text-transform: none;
    height: 44px;
    margin-bottom: 10px;
    color: #0b79d0;
  }

  .date {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .checkbox {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    margin-top: 10px;
    gap: 11px;
  }

  .link {
    margin-top: 10px;
  }

  .section-conference {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .menu-left {
    display: flex;
    flex-direction: column;
  }

  .btn-conference {
    height: 26px;
    border-radius: 32px;
    text-transform: capitalize;
  }

  .section-guests {
    display: flex;
    flex-direction: column;
  }

  .box-items {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .title-conference {
    margin: 0;
  }

  .btn-edit {
    background-color: #206da7;
    color: ${({ theme }) => theme.palette.common.white};
    text-transform: capitalize;
  }

  .btn-rounded {
    border-radius: 32px;
    height: 26px;
  }
  .datetime-input {
    width: 100%;
  }
`;

export const Input = styled(InputComponent)``;

export const VideoconferenceTitle = styled(Typography)`
  color: #000;
  font-size: 16px;
  font-family: Roboto;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.15px;
`;

export const LinkAdress = styled(Box)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  gap: 10px;

  color: rgb(0, 0, 238);
  a {
    white-space: nowrap;
  }
`;

export const SuccessRemovedZoom = styled(Box)`
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TextRemovedZoom = styled(Box)`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.15px;
`;

export const ButtonExternal = styled(Button)`
  border-radius: 4px;
  border: 1px solid #cdcdcd;
  display: flex;
  height: 45px;
  padding: 4px 15px;
  align-items: center;
  gap: 10px;

  font-size: 14px;
  font-family: Roboto;
  line-height: 20px;
  letter-spacing: 0.15px;
  text-transform: none;
  font-weight: 300;
  color: #212b36;

  ${(props: ButtonProps) =>
    props.isActived &&
    css`
      background-color: #cdcdcd54;
    `}
`;

export const ButtonZoom = styled(Button)`
  border-radius: 4px;
  border: 1px solid #cdcdcd;
  display: flex;
  height: 45px;
  padding: 4px 15px;
  align-items: center;
  gap: 10px;

  font-size: 14px;
  font-family: Roboto;
  line-height: 20px;
  letter-spacing: 0.15px;
  text-transform: none;
  font-weight: 300;
  color: #212b36;

  ${(props: ButtonProps) =>
    props.isActived &&
    css`
      background-color: #cdcdcd54;
    `}
`;

export const SuccessOAuth = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 20px;
`;

export const TextZoom = styled(Box)`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.15px;
`;
